import React, { useRef, useEffect, useLayoutEffect, useState } from 'react';
import { Box, Image as GrommetImage, Drop, Spinner, Stack, Table, TableBody, TableRow, TableCell, CheckBox} from 'grommet';
const HRNumbers = require('human-readable-numbers');
const pretty = require('pretty-time');
class Playback extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			modUnits: null,
			logos: null,
			frames: null,
			players: null,
			mapInfo: null,
			playbackDisplayUnits: true,
			playbackDisplayBuildings: false,
			playbackSortByMetal: false
		};
	}
	componentDidMount() {
		this.loadData();
	}
	loadData() {
		if (!this.state.modUnits) {
			fetch("?o=mod_units").then(r => r.json()).then(r => this.setState({modUnits: r}));
		}
		if (!this.state.frames) {
			fetch("?o=playback_frames").then(r => r.json()).then(r => this.setState({frames: r}));
		}
		if (!this.state.players) {
			fetch("?o=players").then(r => r.json()).then(r => this.setState({players: r}));
		}
		if (!this.state.mapInfo) {
			fetch("?o=map_info").then(r => r.json()).then(r => this.setState({mapInfo: r}));
		}
		if (!this.state.logos) {
			fetch("?o=mod_logos").then(r => r.json()).then(r => this.setState({logos: r}));
		}
	}
	smoothMovement(frames) {
		for (const i in frames) {
			for (const u in frames[i].units) {
				const toChange = [];
				const unit = frames[i].units[u];
				if (!unit.nextPos || !unit.nextPos.id) {
					let nextFrame = 0;
					for (let w = i; w < frames.length; w++) {
						if (!(u in frames[w].units) || frames[w].units[u].atom_id != unit.atom_id) {
							break;
						}
						if (unit.pos.id != frames[w].units[u].pos.id) {
							nextFrame = w;
							break;
						}
						toChange.push(w);
					}
					if (nextFrame == 0) {
						frames[i].units[u].nextPos = undefined;
					} else {
						toChange.forEach((w) => {
							frames[w].units[unit.id].nextPos = frames[nextFrame].units[unit.id].pos;
							const unitRef = frames[w].units[unit.id];
							frames[w].units[unit.id].pos = this.updatePos(unitRef, frames[w].ms);
						});
					}
				}
			}
		}
		return frames;
	}
	updatePos(unitRef, ms) {
		const xV = unitRef.nextPos.x - unitRef.pos.x;
		const yV = unitRef.nextPos.y - unitRef.pos.y;
		const mag = Math.sqrt((xV*xV) + (yV*yV));
		if (mag == 0) {
			// Unit remains in the same position.
			// No update required.
			return;
		}
		const xU = xV/mag;
		const yU = yV/mag;
		const td_a = unitRef.nextPos.ms - unitRef.pos.ms;
		const td_b = ms - unitRef.pos.ms;
		const d = td_b/td_a;
		const xN = unitRef.pos.x + parseInt(xU*mag*d);
		const yN = unitRef.pos.y + parseInt(yU*mag*d);
		return {
			x: xN,
			y: yN,
			ms: ms,
		};

	}
	preRender() {
		if (!this.state.frames) return false;
		if (!this.state.players) return false;
		if (!this.state.modUnits) return false;
		if (!this.state.mapInfo) return false;
		if (!this.state.logos) return false;
		return true;
	}
	render() {
		if (!this.preRender()) {
			return <Spinner />;
		}
		const frames = this.smoothMovement(this.state.frames);
		return (
			<div className="playback-container">
			<AnimationCanvas 
			modUnits={this.state.modUnits}
			frames={frames}
			players={this.state.players}
			mapInfo={this.state.mapInfo}
			logos={this.state.logos}
			displayUnits={this.state.playbackDisplayUnits}
			displayBuildings={this.state.playbackDisplayBuildings}
			sortByMetal={this.state.playbackSortByMetal}
			/>
			<Box
			background={{dark: true}} alignSelf="center" pad="medium" gap="small" direction="row">
			<CheckBox
			name="displayUnits"
			checked={this.state.playbackDisplayUnits}
			label="Units"
			onChange={(event) => this.setState({playbackDisplayUnits: (event.target.checked)})}
			/>
			<CheckBox
			name="displayBuildings"
			checked={this.state.playbackDisplayBuildings}
			label="Buildings"
			onChange={(event) => this.setState({playbackDisplayBuildings: (event.target.checked)})}
			/>
			<CheckBox
			name="sortByMetal"
			checked={this.state.playbackSortByMetal}
			label="Sort by Metal"
			onChange={(event) => this.setState({playbackSortByMetal: (event.target.checked)})}
			/>
			</Box>
			</div>
		);
	}
}

function frameRenderer(size, frame, gameSize, unitIcons, playerColorIndex) {
	this.clearRect(0, 0, size.width, size.height);
	const maxDimension = Math.max(size.width, size.height);
	let scale = null;
	if (gameSize.width > gameSize.height) {
		scale = maxDimension / gameSize.width;
	} else {
		scale = maxDimension / gameSize.height;
	}
	if (scale === null) {
		return;
	}
	const drawUnit = (x, y, unit) => {
		const color = playerColorIndex[unit.owner];
		if (unit["class"] == "unit_building") {
			this.drawImage(unitIcons[color].building, x, y);
			return;
		}
		if (unit["class"] == "unit_factory") {
			this.drawImage(unitIcons[color].factory, x, y);
		}
		if (unit["class"] == "unit_mobile") {
			this.drawImage(unitIcons[color].mobile, x, y);
		}
		if (unit["class"] == "unit_commander") {
			this.drawImage(unitIcons[color].commander, x, y);
		}
	};
	for (const id in frame.units) {
		if (!(id in frame.units)) {
			continue;
		}
		const ur = frame.units[id];
		if (!ur.pos) {
			continue;
		}
		const x = parseInt(frame.units[id].pos.x*scale);
		const y = parseInt(frame.units[id].pos.y*scale);
		if (ur.finished) {
			drawUnit(x, y, ur);
		}
	}
	this.fillStyle = "#ffeb00";
	this.font = "24px serif";
	this.direction = "rtl";
	this.fillText(pretty([0, frame.ms * 1e6]), size.width, 24);
}
const LOGO_SIZE = 96;
function clipMobile(logo) {
	const oc = document.createElement("canvas");
	const radius = 3;
	const side = 8;
	oc.width = side;
	oc.height = side;
	const ctx = oc.getContext("2d");
	ctx.beginPath();
	ctx.arc(side/2, side/2, radius, 0, Math.PI * 2);
	ctx.clip();
	ctx.drawImage(logo, 16, 16, side, side, 0, 0, side, side);
	ctx.strokeStyle = "#cbcbcb";
	ctx.stroke();
	return oc;
}
function clipCommander(logo) {
	const oc = document.createElement("canvas");
	const radius = 6;
	const side = 13;
	oc.width = side;
	oc.height = side;
	const ctx = oc.getContext("2d");
	ctx.beginPath();
	ctx.arc(side/2, side/2, radius, 0, Math.PI * 2);
	ctx.clip();
	ctx.drawImage(logo, 16, 16, side, side, 0, 0, side, side);
	ctx.strokeStyle = "#cbcbcb";
	ctx.stroke();
	return oc;
}
function clipFactory(logo) {
	const oc = document.createElement("canvas");
	const side = 12;
	oc.width = side;
	oc.height = side;
	const ctx = oc.getContext("2d");
	ctx.drawImage(logo, 16, 16, side, side, 0, 0, side, side);
	ctx.rect(0, 0, side, side);
	ctx.strokeStyle = "#cbcbcb";
	ctx.stroke();
	return oc;
}
function clipBuilding(logo) {
	const oc = document.createElement("canvas");
	const side = 8;
	oc.width = side;
	oc.height = side;
	const ctx = oc.getContext("2d");
	ctx.drawImage(logo, 16, 16, side, side, 0, 0, side, side);
	ctx.rect(0, 0, side, side);
	ctx.strokeStyle = "#cbcbcb";
	ctx.stroke();
	return oc;
}

const AnimationCanvas = (props) => {
	const canvasRef = useRef();
	const frameRef = useRef({number: 0, speed: 250});
	const requestIdRef = useRef(null);
	const [dimensions, setDimensions] = useState({});
	const [currentFrame, setCurrentFrame] = useState(0); // New state for rendering updates

	// holds the timer for setTimeout and clearInterval
	let movement_timer = null;

	// the number of ms the window size must stay the same size before the
	// dimension state variable is reset
	const RESET_TIMEOUT = 1000;

	const test_dimensions = () => {
		// For some reason canvasRef.current.getBoundingClientRect was not available
		// I found this worked for me, but unfortunately I can't find the
		// documentation to explain this experience
		if (canvasRef.current) {
			const maxWidth = 1024;
			let width = canvasRef.current.offsetWidth;
			if (width > maxWidth) {
				width = maxWidth;
			}
			const heightRatio = props.mapInfo.height / props.mapInfo.width;
			let height = (width * heightRatio) | 0;
			const maxHeight = window.innerHeight * 0.80 | 0;
			if (height > maxHeight) {
				// The window is too small to display the playback vertically.
				// Make the width narrower than maxWidth.
				//
				// Let's try shrinking width by maxHeight / height.
				const widthRatio = maxHeight / height;
				width = width * widthRatio | 0;
				height = maxHeight;
			}
			setDimensions({
				width,
				height,
			});
		}
	};

	// This sets the dimensions on the first render
	useLayoutEffect(() => {
		test_dimensions();
	}, []);
	const iconTypes = ["building", "mobile", "factory", "commander"]
	const unitIcons = [];
	for (const e in props.logos) {
		const img = new Image();
		img.src = props.logos[e];
		img.onload = () => {
			const icons = {};
			iconTypes.map((e) => {
				if (e == "building") {
					icons[e] = clipBuilding(img);
				}
				if (e == "mobile") {
					icons[e] = clipMobile(img);
				}
				if (e == "factory") {
					icons[e] = clipFactory(img);
				}
				if (e == "commander") {
					icons[e] = clipCommander(img);
				}
			});
			unitIcons[e] = icons;
		}
	};
	const playerColorIndex = props.players.map((e) => e.color);
	const renderFrame = (number) => {
		const ctx = canvasRef.current.getContext("2d");
		const frame = frameRef.current;
		frameRenderer.call(ctx, dimensions, props.frames[number], props.mapInfo, unitIcons, playerColorIndex)
	};
	const tick = () => {
		if (!canvasRef.current) return;
		renderFrame();
		requestIdRef.current = requestAnimationFrame(tick);
	};
	const touchWhileStart = (e) => {
		const endTouchMove = () => {
			canvasRef.current.removeEventListener("touchmove", whileTouchMove);
			canvasRef.current.removeEventListener("touchend", endTouchMove);
		};
		canvasRef.current.addEventListener("touchmove", whileTouchMove);
		canvasRef.current.addEventListener("touchend", endTouchMove);
	};
	const mouseWhileDown = (e) => {
		const endMove = () => {
			canvasRef.current.removeEventListener("mousemove", whileMove);
			canvasRef.current.removeEventListener("mouseup", endMove);
		};
		canvasRef.current.addEventListener("mousemove", whileMove);
		canvasRef.current.addEventListener("mouseup", endMove);
	};
	const whileTouchMove = (e) => {
		const bounds = canvasRef.current.getBoundingClientRect();
		const x = e.touches[0].clientX - bounds.left;
		const pos = x / bounds.width;
		const frame = Math.round((props.frames.length-1)*pos);
		if (!canvasRef.current) return;
		if (!frameRef.current) return;
		const fr = frameRef.current;
		if (fr.number == frame) {
			return;
		}
		fr.number = frame;
		renderFrame(fr.number);
		setCurrentFrame(frame);  // Update state to trigger a re-render
	};
	const whileMove = (e) => {
		const bounds = canvasRef.current.getBoundingClientRect();
		const x = e.clientX - bounds.left;
		const pos = x / bounds.width;
		const frame = Math.round((props.frames.length-1)*pos);
		if (!canvasRef.current) return;
		if (!frameRef.current) return;
		const fr = frameRef.current;
		if (fr.number == frame) {
			return;
		}
		fr.number = frame;
		renderFrame(fr.number);
		setCurrentFrame(frame);  // Update state to trigger a re-render
	};

	// every time the window is resized, the timer is cleared and set again
	// the net effect is the component will only reset after the window size
	// is at rest for the duration set in RESET_TIMEOUT.  This prevents rapid
	// redrawing of the component for more complex components such as charts
	window.addEventListener('resize', () => {
		clearInterval(movement_timer);
		movement_timer = setTimeout(test_dimensions, RESET_TIMEOUT);
	});
	const bgImg = "url(\"" + props.mapInfo.pic + "\")";
	const canvasStyle = {
		backgroundImage: bgImg,
		backgroundSize: "cover",
		width: "100%",
		maxWidth: dimensions.width,
		height: dimensions.height,
		cursor: "grab",
		touchAction: "none",
	}
	return (
		<div id="frame-zone">
		<canvas 
		onMouseDown={mouseWhileDown}
		onTouchStart={touchWhileStart}
		width={dimensions.width}
		height={dimensions.height}
		ref={canvasRef} 
		style={canvasStyle}>
			<p>Playback Animation</p>
		</canvas>
		<ArmyDisplay
		currentFrame={currentFrame}
		frames={props.frames}
		players={props.players}
		logos={props.logos}
		modUnits={props.modUnits}
		displayUnits={props.displayUnits}
		displayBuildings={props.displayBuildings}
		sortByMetal={props.sortByMetal}
		/>
		</div>
	);
}
const organizeUnitCounts = (unitCounts, modUnits, displayArgs) => {
	const categorizedUnits = {
		unit_building: [],
		unit_factory: [],
		unit_mobile: []
	};

	// Loop through the unit counts and categorize them by unitClass
	Object.entries(unitCounts).forEach(([unitCategoryId, data]) => {
		const unitClass = data.unitClass; // Use the unitClass from the unitCounts data

		// Categorize units based on their unitClass
		if ((unitClass === "unit_building") && displayArgs["displayBuildings"]) {
			categorizedUnits.unit_building.push([unitCategoryId, data.count]);
		} else if ((unitClass === "unit_factory") && displayArgs["displayBuildings"]) {
			categorizedUnits.unit_factory.push([unitCategoryId, data.count]);
		} else if ((unitClass === "unit_mobile") && displayArgs["displayUnits"]) {
			categorizedUnits.unit_mobile.push([unitCategoryId, data.count]);
		}
	});

	// Sort each category by count in descending order
	if (displayArgs["sortByMetal"]) {
		categorizedUnits.unit_building.sort((a, b) => b[1]*modUnits[b[0]-1].buildcostmetal - a[1]*modUnits[a[0]-1].buildcostmetal);
		categorizedUnits.unit_factory.sort((a, b) => b[1]*modUnits[b[0]-1].buildcostmetal - a[1]*modUnits[a[0]-1].buildcostmetal);
		categorizedUnits.unit_mobile.sort((a, b) => b[1]*modUnits[b[0]-1].buildcostmetal - a[1]*modUnits[a[0]-1].buildcostmetal);
	} else {
		categorizedUnits.unit_building.sort((a, b) => b[1] - a[1]);
		categorizedUnits.unit_factory.sort((a, b) => b[1] - a[1]);
		categorizedUnits.unit_mobile.sort((a, b) => b[1] - a[1]);
	}

	// Return a flattened array of all units in the desired order
	return [
		...categorizedUnits.unit_mobile,
		...categorizedUnits.unit_factory,
		...categorizedUnits.unit_building,
	];
};


const ArmyDisplay = (props) => {
	const [unitCounts, setUnitCounts] = useState({}); // State to store unit counts
	// Function to calculate unit count by owner for the current frame
	const calculateUnitCountByOwner = () => {
		const unitCounts = {};

		// Ensure frames and current frame exist
		const currentFrameData = props.frames[props.currentFrame]?.units;
		if (!currentFrameData) return unitCounts;

		// Iterate through each unit in the current frame
		Object.values(currentFrameData).forEach(unit => {
			const owner = unit.owner;
			const unitCategoryId = unit.unit_category_id;
			const unitClass = unit["class"]; // Access unit class from frame data, now renamed to unitClass

			// Initialize the owner's data if not already present
			if (!unitCounts[owner]) {
				unitCounts[owner] = {};
			}

			// Initialize the unit category with both unitClass and count if not present
			if (!unitCounts[owner][unitCategoryId]) {
				unitCounts[owner][unitCategoryId] = { unitClass: unitClass, count: 0 }; // Renamed to unitClass
			}

			// Increment the count for the unit_category_id
			unitCounts[owner][unitCategoryId].count++;
		});

		return unitCounts;
	};

	const displayArgs = {
		displayUnits: props.displayUnits,
		displayBuildings: props.displayBuildings,
		sortByMetal: props.sortByMetal
	};
	// Use useEffect to recalculate the unit counts whenever currentFrame or frames change
	useEffect(() => {
		const updatedUnitCounts = calculateUnitCountByOwner();
		setUnitCounts(updatedUnitCounts); // Update the state with new counts
	}, [props.currentFrame, frames, props.displayUnits, props.displayBuildings, props.sortByMetal]); // Re-run the effect when currentFrame or frames change
	return (
		<div className="player-legend">
		<table>
		<tbody>
		{props.players.map((player, index) => {
			if (player.side === 2) {
				return null; // Skip side 2 players
			}

			// Get the unit composition for this player (owner)
			const playerUnits = unitCounts[index] || {};

			return (
				<tr key={player.player}>
				<td>
				<img className="p-logo" src={props.logos[player.color]} alt={`Player ${player.player}`} />
				</td>
				<td>{player.player}</td>
				<td>
				<Box direction="row" wrap>
				{organizeUnitCounts(playerUnits, props.modUnits, displayArgs)
					.map(([unitCategoryId, count]) => (
					<Stack
					anchor="top-right"
					key={unitCategoryId}
					>
					<UnitItem
					unit={props.modUnits[unitCategoryId-1]}
					categoryId={unitCategoryId-1}
					count={count}
					/>
					<Box
					background="rgba(38, 38, 38, 0.6)"
					pad="xxsmall"
					>
					<span style={{ color: '#d9d6b3' }}>{count}</span>
					</Box>
					</Stack>
				))}
				</Box>
				</td>
				</tr>
			);
		})}
		</tbody>
		</table>
		</div>
	);
};

class UnitItem extends React.Component {
        state = {};
        ref = React.createRef();
	initToolTip() {
		const unit = this.props.unit;
		const count = this.props.count;
		const cat = this.props.categoryId;
		return (
			<Table>
				<TableBody>
				<TableRow>
				<TableCell>Name</TableCell>
				<TableCell>{unit.name}</TableCell>
				</TableRow>
				<TableRow>
				<TableCell>Metal</TableCell>
				<TableCell>
				{HRNumbers.toHumanString(count * unit.buildcostmetal)}
				</TableCell>
				</TableRow>
				</TableBody>
			</Table>
		);
	}
        render() {
                const { over } = this.state;
                return (
                        <Box ref={this.ref} margin="xsmall">
                        <GrommetImage
                        style={{width: "32px", height: "32px"}}
                        onMouseEnter={() => this.setState({over: true})}
                        onMouseOut={() => this.setState({over: false})}
                        src={this.props.unit.pic}
                        />
                        {this.ref.current && over && (
                                <Drop
                                align={{bottom: "top"}}
                                target={this.ref.current}
                                plain
                                >
                                <Box
                                pad="small"
                                border={{color: "#0F0"}}
                                background="#262626"
                                >
                                {this.initToolTip()}
                                </Box>
                                </Drop>
                        )}
                        </Box>
                );
        }
}


import { createRoot } from 'react-dom/client';
const container = document.getElementById('playback');
const root = createRoot(container);
root.render(<Playback />);

